import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useBrandAccountSurveyGroupsQueryKey } from './useBrandAccountSurveyGroupsQueryKey'

export const useInvalidateBrandAccountSurveyGroupsQuery = (
  brandAccountId: string | undefined,
) => {
  const queryClient = useQueryClient()
  const queryKey = useBrandAccountSurveyGroupsQueryKey(brandAccountId)

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
